/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Grid, Row, Col } from 'react-bootstrap';
import s from './ServicesLayout.css';
import s2 from './ServicesLayout2.scss';
import ServicesHeader from '../ServicesHeader/ServicesHeader';
import ServicesFooter from '../ServicesFooter/ServicesFooter';
import SideBarContainer from '../SideBarMenu/SideBarContainer';
import SideBarButton from '../SideBarMenu/SideBarButton';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import { adminRole } from '../../config';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../utils/utils';
import RODO_CONTENT from '../utils/rodo';
import history from '../../core/history';

const ModalInfo = (props) => {
  return (
    <Modal name={props.name} show={props.show} onHide={props.onHide}>
      <Modal.Header closeButton style={{ color: layoutColorStyle[props.colors].color, backgroundColor: layoutColorStyle[props.colors].backgroundColor }}>
        <Modal.Title ><p style={{ textAlign: 'center' }}>{props.title}</p></Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto', color: layoutColorStyle[props.colors].color, backgroundColor: layoutColorStyle[props.colors].backgroundColor }}>
        {props.bodyText}
      </Modal.Body>
      <Modal.Footer style={{ color: layoutColorStyle[props.colors].color, backgroundColor: layoutColorStyle[props.colors].backgroundColor }}>
        <Button className="btn btn-primary center-block" onClick={props.onSave} >Zapoznałem się</Button>
      </Modal.Footer>
    </Modal>
  );
};

const centerDiv = {
  margin: 'auto',
  // height: 'auto',
  maxWidth: '1040px',
  // minHeight: '750px',
  paddingBottom: '30px',
};

class ServicesLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  state = {
    colors: 'normal',
    viewPopup: true,
  }

  componentDidMount() {
    const visited = localStorage["popupAccepted"];
    if (visited) {
      this.setState({ viewPopup: false });
    }
    const colors = getThemeFromLocalStorage();
    this.setState({ colors });
    document.addEventListener("keydown", this.escFunction, false);
  }

  componentWillUnmount(){
    document.removeEventListener("keydown", this.escFunction, false);
  };

  escFunction(event){
    if (event.key === "Escape") {
      history.goBack();
    }
  };

  setColors = (colors) => {
    localStorage.setItem('colorTheme', colors);
    window.location.reload();
  }

  handleSave = () => {
    localStorage["popupAccepted"] = true;
    this.setState({ viewPopup: false });
  }

  handleHide = () => {
    this.setState({ viewPopup: false })
  }

  render() {
    return <div id="layout-body" style={{ paddingBottom: this.props.footerHeight, fontSize: this.props.fontSize + 'rem', height: '100%', color: layoutColorStyle[this.state.colors].color, backgroundColor: layoutColorStyle[this.state.colors].backgroundColor }}>
      <ServicesHeader setColors={this.setColors} colors={headerStyle[this.state.colors]} {...this.props} />
      {
        this.state.viewPopup &&
        <ModalInfo
          title={"Przeczytaj, jak przetwarzamy twoje dane"}
          bodyText={<RODO_CONTENT prefix={this.props.prefix}/>} // ten prop powoduje blad
          show={this.state.viewPopup}
          name="viewPopupModal"
          onSave={this.handleSave} // ten prop powoduje blad
          colors={this.state.colors} // ten prop powoduje blad
          onHide={this.handleHide}
        />
      }
      {
        this.props.sidePanel ?
          <Grid style={{ width: '100%' }}>
            <Row>
              <Col xs={12} sm={2}>
                <SideBarContainer width={100}>
                  <SideBarButton colorStyle={headerStyle[this.state.colors]} link={`/panel`} active={this.props.active_panel && this.props.active_panel === 'moje_dane'} text="Moje dane" icon="fa-home" />
                  <SideBarButton colorStyle={headerStyle[this.state.colors]} link={`/panel/${this.props.username}/mojedokumenty`} active={this.props.active_panel && this.props.active_panel === 'dokumenty'} text="Dokumenty" icon="fa-file-text" styl="meledutki" />
                  <SideBarButton link={`/panel/${this.props.username}/usunkonto`} active={this.props.active_panel && this.props.active_panel === 'usun_konto'} text="Usuń konto" icon="fa-trash" styl="meledutki" />
                  <SideBarButton colorStyle={headerStyle[this.state.colors]} link={`/panel/${this.props.username}/mojezapytania`} active={this.props.active_panel && this.props.active_panel === 'moje_zapytania'} text="Moje zapytania" icon="fa-envelope" styl="meledutki" />
                  {/* <SideBarButton colorStyle={headerStyle[this.state.colors]} link={`/panel/${this.props.username}/rodo`} active={this.props.active_panel && this.props.active_panel === 'rodo'} text="RODO" icon="fa-envelope" styl="meledutki" /> */}
                </SideBarContainer>
                { this.props.userRoles.indexOf(adminRole) >= 0 ?
                <SideBarContainer width={100}>
                  <SideBarButton colorStyle={headerStyle[this.state.colors]} link={`/panel/${this.props.username}/statusgmin`} active={this.props.active_panel && this.props.active_panel === 'status_gmin'} text="Status gmin" icon="fa-home" />
                  <SideBarButton colorStyle={headerStyle[this.state.colors]} link={`/panel/${this.props.username}/zestawienia`} active={this.props.active_panel && this.props.active_panel === 'zestawienia_gminne'} text="Zestawienia gminne" icon="fa-home" />
                </SideBarContainer>: null}
              </Col>
              <Col className="rwd-class" xs={12} sm={10}>{this.props.children}</Col>
            </Row>
          </Grid> :
          <div>
            <Row style={centerDiv}>
              <Col className="rwd-class" xs={12}>{this.props.children}</Col>
            </Row>
          </div>
      }
      {!this.props.withoutFooter ? <ServicesFooter colors={headerStyle[this.state.colors]} absoluteFooter={this.props.absoluteFooter} prefix={this.props.prefix} /> : null}
    </div>;
  }
}

const mapState = (state) => ({
  fontSize: state.runtime.fontSize,
  username: state.user ? state.user.username : null,
  footerHeight: state.eservices.footerHeight,
  userRoles: (state.user && state.user.roles !== undefined) ? state.user.roles : [],
});

export default withStyles(s, s2)(connect(mapState)(ServicesLayout));



// WEBPACK FOOTER //
// src/components/ServicesLayout/ServicesLayout.js